module.exports = function getResource(label) {
    const resources = { qty: 'Quantity', loved: 'Loved', moveToLoves: 'Move to Loves', getItSooner: 'Get It Sooner' };
    return resources[label];
};
